"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = OfferPrice;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _r10SourceLibrary = require("r10-source-library");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CrossedSpan = _styledComponents.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  text-decoration: line-through;\n"])));
function OfferPrice(_ref) {
  var index = _ref.index,
    finalPriceWithSymbol = _ref.finalPriceWithSymbol,
    catalogPriceWithSymbol = _ref.catalogPriceWithSymbol,
    perMonthText = _ref.perMonthText;
  var breakPoint = (0, _r10SourceLibrary.useBreakpoints)();
  return /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3,
    justify: breakPoint.sm ? 'center' : 'left'
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 2
  }, /*#__PURE__*/_react.default.createElement(CrossedSpan, {
    "data-testid": "offer-card-crossed-price-".concat(index)
  }, catalogPriceWithSymbol)), "\xA0", /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 4,
    appearance: "secondary"
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-testid": "offer-card-price-".concat(index)
  }, " ", finalPriceWithSymbol)), "\xA0", /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Span, {
    weight: 3
  }, perMonthText));
}
OfferPrice.propTypes = {
  index: _propTypes.default.number,
  finalPriceWithSymbol: _propTypes.default.string,
  catalogPriceWithSymbol: _propTypes.default.string,
  perMonthText: _propTypes.default.string
};